import React from 'react'
import { BrComponentContext, BrPageContext } from '@bloomreach/react-sdk'
import { HippostdHtml } from '../blog/blogArticle/componentTypes/HippostdHtml.jsx'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'

const FooterDisclosure = () => {
  const component = React.useContext(BrComponentContext)
  const page = React.useContext(BrPageContext)
  const content = page.getContent(
    component.getChildren()[0].getModels().document['$ref']
  ).model.data.content
  return (
    content && (
      <div className="Footer-disclosures Content u-paddingBottom2gu u-posRelative">
        <HippostdHtml
          value={content.value}
          classNames="Content-block"
        ></HippostdHtml>
      </div>
    )
  )
}

export default function ErrorWrapperFooterDisclosure(props) {
  return (
    <ErrorBoundary
      fallback={() =>
        !isProduction() ? <p>Erorr in FooterDisclosure component</p> : null
      }
    >
      <FooterDisclosure {...props}></FooterDisclosure>
    </ErrorBoundary>
  )
}
